module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMABBgcHyMkKzc7PE9faG9zd3t/h4+Tl5+jq6+3x9fb5+/z9/tSd9dRAAAAtUlEQVQ4y8XTy3bCIBhF4Q1VUm16w0v6J1JLc97/GTtx4AWStRzYPeUbAQeWllUp2xJC9ViScsA0mZGnQUYzPRQctjFu+rEK3gFgnSsgceolxhh3hxvQcdnHHOC7BFadB79/BvgqgajkfdInQFcCzpSSzFUBrpd6Rx34JCVfBz7J7CSKYCtzzhRLYAB4enPgXj3AcAV+m8t7asbrxzq2i7Pa47/8qLvB7HBmpzc93p8AYWr+gT8543PcPAaf+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shwtg-w.png
// module id = WL88
// module chunks = 1